import React from "react";

import { useLocalStorage } from "../../../hooks";
import { userState } from "../../../redux/reducers/userReducer";


import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { TwButton, TwCalendarPicker, TwDialog, TwInputGroup, TwSelectGroup } from "../../../components/tailwind";
import { useToast } from "../../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading, setSectionLoading } from "../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForBookings, getUrlForClasses } from "../../../utils/confighelpers";
import copy_squares from "../../../assets/square.on.square.svg";
import { billingPeriod } from "../../../utils/constants";
import calender_black from "../../../assets/calender_black.svg";
import moment from "moment/moment";


export default function PurchasesGeneralDialog({
    allowProductType = "classpass",
    openGeneralCreditDialog,
    setOpenGeneralCreditDialog,
    customerInfo,
    reloadData = () => { },
}) {
    const { addToast, addSuccessToast, addErrorToast, addNotificationDialog } = useToast();
    const location = useLocation();
    const [userToken] = useLocalStorage("userToken");
    const dispatch = useDispatch();
    const loadingReduxState = useSelector(loadingState);
    const userReduxState = useSelector(userState);
    const [classList, setClassList] = React.useState([]);
    const [multiSessionPassList, setMultiSessionPassList] = React.useState([]);
    const [productsList, setProductsList] = React.useState([]);
    const defaultFormData = {
        // "selectedClass": {},
        // "selectedPass": {},
        "selectedProduct": {},
        // "classId": "",
        // "selectedPassId": "",
        "productId": "",
        "migrationCredit": 1,
        // "type": "add", //only for class
        // "isPackage": false, //only for class
        // "isEvent": false, //only for class
        "username": "",
        "fullName": "",
        "email": "",
        // "purchaseId": "",
        // "isPaid": true, //only for class
        // "paymentMethod": "NA", //only for class
        // "paymentMode": "Online", //only for class
        // "paymentStatus": "Paid", //only for class
        "paymentMethod": "NA",
        "paymentMode": "NA",
        "paymentStatus": "Paid",
        // "billStartingFrom": new Date()
    }
    const [formValues, setFormValues] = React.useState(defaultFormData);
    const [formErrors, setFormErrors] = React.useState({});
    const [purchaseComplete, setPurchaseComplete] = React.useState(false);
    const [allowMarkAsPaid, setAllowMarkAsPaid] = React.useState(false);
    const [paymentLink, setPaymentLink] = React.useState("");
    const [purchasingInfo, setPurchasingInfo] = React.useState({});
    const [invoiceAction, setInvoiceAction] = React.useState("");

    const getListOfClass = async () => {
        let mgClasses = [];
        const manageClassesConfig = {
            method: "get",
            url: `${getUrlForClasses()}listOfClasses?isPackage=${false}&listFor=${userReduxState.businessType}&onlyClassDetail=true`,
        };
        dispatch(setSectionLoading(true));
        const manageClassesRequest = await axiosInstance(manageClassesConfig);
        dispatch(setSectionLoading(false));
        if (manageClassesRequest.status === 200) {
            if (manageClassesRequest.data.data.length) {
                setClassList(manageClassesRequest.data.data);
            }
        }
    };

    const getProductsList = async (page = 1) => {
        const config = {
            method: "get",
            url: `${getUrlForClasses("")}products/list?getall=false`,
        };
        dispatch(setGlobalLoading(true));
        const productRequest = await axiosInstance(config);
        dispatch(setGlobalLoading(false));
        if (productRequest.status === 200) {
            // console.log("productRequest.data.data", productRequest.data.data.data);

            if (productRequest.data.data.length) {
                setProductsList(productRequest.data.data);
            }
        }
    };

    const handleSubmit = async () => {
        const errors = {};
        // if (!Object.keys(formValues.selectedClass).length) {
        //     errors.selectedClass = "Required!";
        // }
        // if (!Object.keys(formValues.selectedPass).length) {
        //     errors.selectedPass = "Required!";
        // } else if (Object.keys(formValues.selectedPass).length && parseFloat(formValues.selectedPass.amount) > 0) {
        //     errors.selectedPass = "The amount of 'Migration Credit' pass should be zero(0)";
        // }
        if (!Object.keys(formValues.selectedProduct).length) {
            errors.selectedProduct = "Required!";
        } else if (Object.keys(formValues.selectedProduct).length && parseFloat(formValues.selectedProduct.price) <= 0) {
            errors.selectedProduct = "The price of 'Migration Credit' pass should be greater than zero(0)";
        }

        // if (allowProductType === "subscription"
        //     && formValues?.selectedProduct?.productFields?.billingPeriod.interval !== "day"
        //     && !formValues.billStartingFrom) {
        //     errors.billStartingFrom = "Please select bill date.";
        // }

        // if (formValues.migrationCredit <= 0) {
        //     errors.migrationCredit = "Credit must be greater than 0.";
        // }
        // if (formValues.migrationCredit % 1 !== 0) {
        //     errors.migrationCredit = "Please enter decimal value!";
        // }
        setFormErrors({ ...errors });
        if (Object.keys(errors).length > 0) {
            console.log("errors", errors);
            addErrorToast("Please fix errors below", { hideAfter: 3 });
            return;
        }
        setFormValues((prevValues) => ({
            ...prevValues,
            // classId: formValues.selectedClass._id,
            // selectedPassId: formValues.selectedPass._id,
            productId: formValues.selectedProduct._id,
        }));

        let body = {
            ...formValues,
            // migrationCredit: parseInt(formValues.selectedProduct.productFields.noOfAllowedSessions),
            productId: formValues.selectedProduct._id,
            username: customerInfo?.username || "",
            fullName: customerInfo?.fullName || "",
            email: customerInfo?.email || "",
            isPaid: false,
            paymentMethod: "NA",
            paymentMode: "NA",
            paymentStatus: "Unpaid",
            generatePaymentLink: true,
            // ...allowProductType === "subscription"
            //     && formValues?.selectedProduct?.productFields?.billingPeriod.interval !== "day" ? { billStartingFrom: moment(formValues.billStartingFrom).format('YYYY-MM-DD') } : {},
        };
        delete body.selectedClass
        delete body.selectedPass
        delete body.selectedProduct
        // if (formValues?.selectedProduct?.productFields?.billingPeriod.interval === "day") {
        //     delete body?.billStartingFrom
        // }

        // console.log("body", body);
        // if (!body.username || !body.fullName || !body.email || !body.classId || !body.selectedPassId) {
        if (!body.username || !body.fullName || !body.email || !body.productId) {
            errors.selectedProduct = "Purchase detail required!";
        }
        setFormErrors({ ...errors });
        if (Object.keys(errors).length > 0) {
            console.log("errors", errors);
            addErrorToast("Please fix errors below", { hideAfter: 3 });
            return;
        }
        let config = {
            method: "post",
            url: `${getUrlForBookings()}purchaseClassPass`,
            data: body,
        };
        // setPurchaseComplete(true)
        // console.log("config.body", body);
        // return;

        dispatch(setGlobalLoading(true));
        dispatch(setActionLoading(true));
        const request = await axiosInstance(config);
        dispatch(setActionLoading(false));
        dispatch(setGlobalLoading(false));

        if (request.status === 200) {
            if (request.data.statusCode === 200) {
                let purchasingInfo = request.data.data.purchasingInfo;
                console.log("purchasingInfo", purchasingInfo);
                setPurchasingInfo(purchasingInfo)
                reloadData()
                setPurchaseComplete(purchasingInfo.stripeMetadata.stripeinvoiceId !== undefined && purchasingInfo.stripeMetadata.stripeinvoiceId !== "" ? true : false)
                setAllowMarkAsPaid((purchasingInfo?.selectedPassDetail?.productType && purchasingInfo?.selectedPassDetail?.productType != "subscription") || purchasingInfo.purchasingFor != "product-subscription" || false)
                if (purchasingInfo.stripeMetadata.stripeinvoiceId === undefined || purchasingInfo.stripeMetadata.stripeinvoiceId === null || purchasingInfo.stripeMetadata.stripeinvoiceId === "") {
                    setOpenGeneralCreditDialog(false)
                    addNotificationDialog({
                        dialogType: "success",
                        dialogTitle: "Success",
                        dialogMessage: `The future subscription is added for this member ${customerInfo?.fullName}.`,
                        dialogBtnTitle: "OK",
                    })
                }
                // addSuccessToast("Your customer credit migrated successfully");
                // setFormValues(defaultFormData);
                // setOpenGeneralCreditDialog(false)
                return;
            } else if (request.data.statusCode === 403) {
                addErrorToast(request.data.message);
            }
        } else {
            addErrorToast(request?.data?.message?.errors ? "Something is wrong please try again" : request.data.message);
        }

    };

    const sendInvoiceWithPaymentLink = async () => {
        setInvoiceAction("sendInvoiceWithPaymentLink")
        const errors = {};
        if (!Object.keys(purchasingInfo).length) {
            addErrorToast("Purchase detail is not available");
            return false;
        }
        if (purchasingInfo._id === undefined) {
            addErrorToast("Purchase detail is not available");
            return false;
        }

        let body = {
            purchase_id: purchasingInfo._id,
        };

        // console.log("body", body);
        let config = {
            method: "post",
            url: `${getUrlForBookings()}sendStripeInvoiceEmail`,
            data: body,
        };
        // console.log("config.body", body);
        // return;

        dispatch(setGlobalLoading(true));
        dispatch(setActionLoading(true));
        const request = await axiosInstance(config);
        dispatch(setActionLoading(false));
        dispatch(setGlobalLoading(false));
        setInvoiceAction("")

        if (request.status === 200) {
            if (request.data.statusCode === 200) {
                let response = request.data.data;
                console.log("response", response);
                reloadData()
                addNotificationDialog({
                    dialogType: "success",
                    dialogTitle: "Success",
                    dialogMessage: `An invoice for this product with a payment link has been sent to ${customerInfo?.email}.`,
                    dialogBtnTitle: "OK",
                })
                clearForm(true)
                setOpenGeneralCreditDialog(false)
                return;
            } else if (request.data.statusCode === 403) {
                addErrorToast(request.data.message);
            }
        } else {
            addErrorToast(request?.data?.message?.errors ? "Something is wrong please try again" : request.data.message);
        }

    };

    const markAsPaidInvoice = async () => {
        setInvoiceAction("markAsPaidInvoice")
        const errors = {};
        if (!Object.keys(purchasingInfo).length) {
            addErrorToast("Purchase detail is not available");
            return false;
        }
        if (purchasingInfo._id === undefined) {
            addErrorToast("Purchase detail is not available");
            return false;
        }

        let body = {
            purchase_id: purchasingInfo._id,
        };

        // console.log("body", body);
        let config = {
            method: "post",
            url: `${getUrlForBookings()}markAsPayStripeInvoice`,
            data: body,
        };
        // console.log("config.body", body);
        // return;

        dispatch(setGlobalLoading(true));
        dispatch(setActionLoading(true));
        const request = await axiosInstance(config);
        dispatch(setActionLoading(false));
        dispatch(setGlobalLoading(false));
        setInvoiceAction("")

        if (request.status === 200) {
            if (request.data.statusCode === 200) {
                let response = request.data.data;
                console.log("response", response);
                reloadData()
                addNotificationDialog({
                    dialogType: "success",
                    dialogTitle: "Success",
                    // dialogMessage: `This purchase is mark as paid Successfully.`,
                    dialogMessage: `Invoice for this product with status paid has been sent to ${customerInfo?.email}.`,
                    dialogBtnTitle: "OK",
                })
                clearForm(true)
                setOpenGeneralCreditDialog(false)
                return;
            } else if (request.data.statusCode === 403) {
                addErrorToast(request.data.message);
            }
        } else {
            addErrorToast(request?.data?.message?.errors ? "Something is wrong please try again" : request.data.message);
        }

    };

    const clearForm = () => {
        setFormValues(defaultFormData);
        setFormErrors({});
        setPurchasingInfo({});
        setPurchaseComplete(false);
        setAllowMarkAsPaid(false);
    }

    React.useEffect(() => {
        (async () => {
            // await getListOfClass();
            await getProductsList();
        })();
    }, []);

    React.useEffect(() => {
        setFormValues((prevValues) => ({
            ...prevValues,
            username: customerInfo?.username || "",
            fullName: customerInfo?.fullName || "",
            email: customerInfo?.email || "",
        }));
    }, [customerInfo]);

    // console.log("customerInfo-1", customerInfo);

    return (
        <TwDialog
            dialogTitle={purchaseComplete ? "" : "Add Product"}
            dialogOpen={openGeneralCreditDialog}
            isFullContent={true}
            onClose={(v) => { clearForm(); setOpenGeneralCreditDialog(false) }}
        >
            <div className="flex flex-col w-full  gap-2">
                {purchaseComplete ? (
                    <div className={"flex flex-col gap-4"}>
                        <div className={"flex flex-col justify-center items-center gap-5"}>
                            <svg width="54" height="55" viewBox="0 0 54 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.2501 23.1182L27.5809 28.6162C28.5224 29.3224 29.8491 29.1836 30.6242 28.2978L45.0001 11.8682" stroke="#481B3A" stroke-width="2.25" stroke-linecap="round" />
                                <path d="M47.25 27.6191C47.25 31.8502 45.9247 35.9751 43.4601 39.4143C40.9956 42.8536 37.5157 45.4344 33.5091 46.7945C29.5026 48.1545 25.1707 48.2254 21.1217 46.9972C17.0728 45.769 13.5103 43.3033 10.9346 39.9466C8.35886 36.5898 6.89928 32.5105 6.76084 28.2817C6.6224 24.0529 7.81206 19.8869 10.1627 16.3688C12.5134 12.8508 15.907 10.1575 19.8669 8.66705C23.8269 7.17664 28.1542 6.96405 32.2411 8.05914" stroke="#481B3A" stroke-width="2.25" stroke-linecap="round" />
                            </svg>

                            <h2 className="text-center text-xl md:text-2xl font-bold tracking-tight text-brown-coffee">
                                Product Added Successfully
                            </h2>
                            <p className={"text-brown-coffee text-base  text-center"}>
                                {/* A confirmation email with a payment link has been sent to <strong>{customerInfo?.email}</strong>. */}
                            </p>
                            <div className="flex flex-col gap-3 sm:items-center">
                                <TwButton variant={"brown-coffee"}
                                    onClick={async () => {
                                        await sendInvoiceWithPaymentLink()
                                    }}
                                    actionLoading={(invoiceAction == "sendInvoiceWithPaymentLink" && loadingReduxState.actionLoading)}
                                >
                                    Send Invoice with Payment Link
                                </TwButton>
                                {allowMarkAsPaid && (<TwButton variant={"brown-coffee-outline"}
                                    onClick={async () => {
                                        await markAsPaidInvoice()
                                    }}
                                    actionLoading={(invoiceAction == "markAsPaidInvoice" && loadingReduxState.actionLoading)}>
                                    Send invoice as Paid
                                </TwButton>)}
                                {/* {paymentLink && (<div className={"flex flex-col gap-10 p-8 pt-4 w-full"}>
                                    <button
                                        className={
                                            "sm:min-w-80 h-14 bg-white rounded-xl flex flex-row items-center gap-2 px-4 py-2 border border-gray-300"
                                        }
                                        onClick={async () => {
                                            try {
                                                await navigator.clipboard.writeText(paymentLink);
                                                addSuccessToast("Copied!");
                                            } catch (e) {
                                                addErrorToast("Failed to copy!");
                                            }
                                        }}
                                    >
                                        <span className={"grow font-semibold text-brown-coffee truncate"}>
                                            {typeof paymentLink === 'string' && paymentLink.slice(0, 35)}...
                                        </span>
                                        <span className={"flex flex-col items-center"}>
                                            <img src={copy_squares} alt={""} />
                                            <p className={"text-[7px] font-semibold text-black"}>Copy</p>
                                        </span>
                                    </button>
                                </div>)} */}
                            </div>
                        </div>
                    </div>
                ) : (<div className="flex flex-col gap-2 overflow-auto relative z-50">
                    {/* <TwSelectGroup
                    label={"Class"}
                    placeholder={"Select Class"}
                    name={"selectedClass"}
                    // leftIcon={<img src={marker} alt={""} className="w-4" />}
                    options={[{
                        value: "", title: "Select Class...",
                    }, ...classList.length ? classList.map((cls, idx) => {
                        return { value: JSON.stringify(cls), title: cls.className }
                    }) : []]}
                    defaultValue={JSON.stringify(formValues.selectedClass)}
                    value={JSON.stringify(formValues.selectedClass)}
                    onChange={(event) => {
                        setFormErrors({});
                        const newValue = JSON.parse(event.target.value);
                        let tempmultiSessionPassList = newValue?.multiSessionPassList || [];
                        console.log("event.target.value", newValue);
                        console.log("tempmultiSessionPassList", tempmultiSessionPassList);
                        tempmultiSessionPassList = tempmultiSessionPassList.filter((d) => parseFloat(d.amount) <= 0)
                        setMultiSessionPassList(tempmultiSessionPassList)
                        console.log("tempmultiSessionPassList.filter", tempmultiSessionPassList);
                        if (tempmultiSessionPassList.length <= 0) {
                            setFormErrors({ selectedPass: "Please create a 'Migration Credit' pass." });
                        }
                        setFormValues((prevValues) => ({
                            ...prevValues,
                            selectedClass: newValue,
                        }));

                    }}
                    errors={formErrors} />
                <TwSelectGroup
                    label={"Migration Credit Pass"}
                    placeholder={"Select Pass"}
                    name={"selectedPass"}
                    options={[{
                        value: "", title: "Select Pass...",
                    }, ...multiSessionPassList.length ? multiSessionPassList.map((cls, idx) => {
                        return { value: JSON.stringify(cls), title: cls.passName }
                    }) : []]}
                    defaultValue={JSON.stringify(formValues.selectedPass)}
                    value={JSON.stringify(formValues.selectedPass)}
                    onChange={(event) => {
                        const newValue = JSON.parse(event.target.value);
                        console.log("newValue", newValue);
                        setFormValues((prevValues) => ({
                            ...prevValues,
                            selectedPass: newValue,
                        }));

                    }}
                    errors={formErrors} /> */}
                    <TwSelectGroup
                        label={"Select Product"}
                        placeholder={"Select Product"}
                        name={"selectedProduct"}
                        // leftIcon={<img src={marker} alt={""} className="w-4" />}
                        options={[{
                            value: "", title: "Select Product...",
                            // }, ...productsList.length ? productsList.filter((d) => parseFloat(d.price) > 0).map((cls, idx) => {
                        }, ...productsList.length ? productsList.filter((d) => parseFloat(d.price) > 0 && d.productType == allowProductType).map((cls, idx) => {
                            return { value: JSON.stringify(cls), title: cls.productName }
                        }) : []]}
                        defaultValue={JSON.stringify(formValues.selectedProduct)}
                        value={JSON.stringify(formValues.selectedProduct)}
                        onChange={(event) => {
                            const newValue = JSON.parse(event.target.value);
                            console.log("newValue", newValue);
                            setFormValues((prevValues) => ({
                                ...prevValues,
                                selectedProduct: newValue,
                                // migrationCredit: newValue,
                            }));

                        }}
                        errors={formErrors} />
                    {/* {false && allowProductType === "subscription"
                        && formValues.selectedProduct.productType === "subscription"
                        && formValues?.selectedProduct?.productFields?.billingPeriod.interval !== "day"
                        && (<TwCalendarPicker
                            label={"Bill starting"}
                            name={"billStartingFrom"}
                            leftIcon={(<img className={""} src={calender_black} alt={""} />)}
                            format="MM/DD/YYYY"
                            value={(formValues.billStartingFrom) ? formValues.billStartingFrom : null}
                            // minDate={moment().subtract(1,"day").toDate()}
                            minDate={moment().set({ hour: 0, minute: 0, second: 0 }).toDate()}
                            onChange={(event) => {
                                const newValue = event?.toDate();
                                console.log(newValue !== undefined && newValue !== "" ? newValue : moment().set({ hour: 0, minute: 0, second: 0 }).toDate());
                                setFormValues((prevValues) => ({
                                    ...prevValues,
                                    billStartingFrom: newValue !== undefined && newValue !== "" ? newValue : moment().set({ hour: 0, minute: 0, second: 0 }).toDate(),
                                }));
                            }}
                            errors={formErrors} />)} */}
                    {formValues.selectedProduct._id && (
                        <div className="flex flex-col gap-1">
                            <div className="text-sm text-gray-600">Product Name: <strong>{formValues.selectedProduct.productName || "0"}</strong></div>
                            {formValues.selectedProduct.productType === "subscription" && (<div className="text-sm text-gray-600">Description: <strong>{formValues.selectedProduct.productDesc || ""}</strong></div>)}
                            {formValues.selectedProduct.productType === "subscription" ? (<div className="text-sm text-gray-600">Credits: <strong>Unlimited</strong></div>) : (<div className="text-sm text-gray-600">Credits: <strong>{formValues.selectedProduct.productFields?.noOfAllowedSessions || 0}</strong></div>)}
                            <div className="text-sm text-gray-600">Validity: <strong>{
                                formValues.selectedProduct.productType === "subscription" ?
                                    // JSON.stringify(formValues)
                                    (<>Renewed {billingPeriod.find((f) => f.data.interval == formValues?.selectedProduct?.productFields?.billingPeriod.interval && f.data.interval_count == formValues?.selectedProduct?.productFields?.billingPeriod.interval_count).title}</>)
                                    :
                                    (formValues.selectedProduct?.productFields?.validUntilConsumed === true) ? <span style={{ p: 0, fontSize: 14, lineHeight: "14px" }}>Until Consumed</span> : parseInt(formValues.selectedProduct?.productFields?.validityDays)}</strong> {(formValues.selectedProduct?.productFields?.validUntilConsumed === false) && (<span className="text-sm text-gray-500 max-w-24 text-wrap text-center">days from purchase date</span>)}</div>
                        </div>
                    )}
                    {/* <TwInputGroup
                    label={"Migration Credit"}
                    placeholder={"Credit (in Number)"}
                    type={"number"}
                    name={"migrationCredit"}
                    value={formValues.migrationCredit}
                    onChange={(event) => {
                        setFormValues((prevValues) => ({
                            ...prevValues,
                            migrationCredit: event.target.value,
                        }));

                    }}
                    errors={formErrors}
                    // className="!py-3 md:pl-2.5"
                    helperText="no. of migration credit for this pass"
                /> */}
                    <div className={"flex gap-4 justify-center pt-5 w-full sm:w-full sm:max-w-sm md:max-w-lg"}>
                        <TwButton
                            variant={"orange-outline"}
                            className={"w-full"}
                            disabled={loadingReduxState.actionLoading}
                            onClick={() => {
                                clearForm();
                                setOpenGeneralCreditDialog(false)
                            }}
                        >
                            Cancel
                        </TwButton>
                        <TwButton
                            variant={"orange"}
                            className={"w-full"}
                            disabled={loadingReduxState.actionLoading}
                            actionLoading={(loadingReduxState.actionLoading)}
                            onClick={() => {
                                handleSubmit();
                            }}
                        >
                            Add Product
                        </TwButton>
                    </div>
                </div>)}
            </div>
        </TwDialog>
    );
}
